export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=04e3f254"


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/File/Lifting/index.vue?vue&type=template&id=04e3f254
// module id = 1943
// module chunks = 31